import axios, { InternalAxiosRequestConfig, AxiosResponse } from "axios";
import router from "@/router";
import { resolveAppBaseApi } from "@/microfrontends/monitor-mfe/sdk/sdk-api-config";
import { getSdkRequestToken } from "@/microfrontends/monitor-mfe/sdk/sdk-auth";

// 创建 axios 实例
const service = axios.create({
  baseURL: resolveAppBaseApi(),
  timeout: 50000,
  headers: { "Content-Type": "application/json;charset=utf-8" },
});

// 请求拦截器
service.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    config.headers["token"] = getSdkRequestToken();
    // config.headers[REQUEST_ID] = uuidv4()
    if (!config.url?.includes(".json")) {
      config.baseURL = resolveAppBaseApi();
    } else {
      config.baseURL = "/";
    }
    return config;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);


// 响应拦截器
service.interceptors.response.use(
  (response: AxiosResponse) => {
    const { code, message } = response.data;
    // 根据 code 进行判断
    if (code === undefined) {
      // 如果没有 code 代表这是非约定返回 或者不是项目后端开发的接口
      return response.data;
    } else {
      // 有 code 代表这是一个后端接口 可以进行进一步的判断
      switch (code) {
        case "0":
          // [ 示例 ] code === 0 代表没有错误
          // return dataAxios.data
          return response.data;
        case 0:
          // [ 示例 ] code === 0 代表没有错误
          // return dataAxios.data
          return response.data;
        case "00000":
          // [ 示例 ] code === 0 代表没有错误
          // return dataAxios.data
          return response.data;
        case 200:
          // [ 示例 ] code === 0 代表没有错误
          // return dataAxios.data
          return response.data;
        case 401:
          ElMessage({
            type: "error",
            message: "未授权，请登录401",
            customClass: "global-soft-message",
            showClose: true,
            duration: 3200,
          });
          sessionStorage.clear();
          localStorage.clear();
          router.push("/login");
          break;
        case 403:
          ElMessage({
            type: "error",
            message: "拒绝访问403",
            customClass: "global-soft-message",
            showClose: true,
            duration: 3200,
          });
          break;
        case 404:
          ElMessage({
            type: "error",
            message: "请求地址出错404",
            customClass: "global-soft-message",
            showClose: true,
            duration: 3200,
          });
          break;
        case 408:
          ElMessage({
            type: "error",
            message: "请求超时",
            customClass: "global-soft-message",
            showClose: true,
            duration: 3200,
          });
          break;
        case 500:
          ElMessage({
            type: "error",
            message: "服务器内部错误500",
            customClass: "global-soft-message",
            showClose: true,
            duration: 3200,
          });
          break;
        case 501:
          ElMessage({
            type: "error",
            message: "服务未实现",
            customClass: "global-soft-message",
            showClose: true,
            duration: 3200,
          });
          break;
        case 502:
          ElMessage({
            type: "error",
            message: "网关错误502",
            customClass: "global-soft-message",
            showClose: true,
            duration: 3200,
          });
          break;
        case 503:
          ElMessage({
            type: "error",
            message: "服务不可用",
            customClass: "global-soft-message",
            showClose: true,
            duration: 3200,
          });
          break;
        case 504:
          ElMessage({
            type: "error",
            message: "网关超时504",
            customClass: "global-soft-message",
            showClose: true,
            duration: 3200,
          });
          break;
        case 505:
          ElMessage({
            type: "error",
            message: "HTTP版本不受支持",
            customClass: "global-soft-message",
            showClose: true,
            duration: 3200,
          });
          break;
        default:
          // 不是正确的 code
          ElMessage({
            type: "error",
            message: message,
            customClass: "global-soft-message",
            showClose: true,
            duration: 3200,
          });
          return Promise.reject(response.data);
      }
    }
  },
  (error: any) => {
    // console.log(error)
    // ElMessage.error(error.message);
    switch (error.status) {
      case 401:
        ElMessage.error("未授权，请登录401");
        sessionStorage.clear();
        localStorage.clear();
        router.push("/login");
        break;
      case 403:
        ElMessage.error("拒绝访问403");
        break;
      case 404:
        ElMessage.error(`请求地址出错404`);
        break;
      case 408:
        ElMessage.error("请求超时");
        break;
      case 500:
        ElMessage.error("服务器内部错误500");
        break;
      case 501:
        ElMessage.error("服务未实现");
        break;
      case 502:
        ElMessage.error("网关错误502");
        break;
      case 503:
        ElMessage.error("服务不可用");
        break;
      case 504:
        ElMessage.error("网关超时504");
        break;
      case 505:
        ElMessage.error("HTTP版本不受支持");
        break;
      default:
        // 不是正确的 code
        ElMessage({
          type: "error",
          message: error.message,
          customClass: "global-soft-message",
          showClose: true,
          duration: 3200,
        });
    }
    return Promise.reject(error);
  }
);
  
  // 导出 axios 实例
  export default service;
